document.addEventListener("DOMContentLoaded", () => {
  const productInfoElement = document.querySelector('.main-product__info-wrapper');
  const mediaElement = document.getElementById("mobile-product__info-wrapper");
  const productFormElement = document.querySelector('product-form');
  if (window.innerWidth < 768) {
    mediaElement.insertAdjacentElement("beforeend", productInfoElement);
  }
  window.addEventListener('resize', () => {
    if (window.innerWidth < 768) {
      var ua = navigator.userAgent.toLowerCase();
      var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
      if (!isAndroid) {
        mediaElement.insertAdjacentElement("beforeend", productInfoElement);
      }
    } else {
      document.querySelector(".main-product-grid__item").insertAdjacentElement("afterend", productInfoElement);
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const productFormElement = document.querySelector('product-form');
  const cloneElement = productFormElement.cloneNode(true);
  document.querySelector("#MainContent").appendChild(cloneElement);
  cloneElement.classList = 'product-form_fixed';
});


document.addEventListener("DOMContentLoaded", () => {
  let selectPlan = document.querySelectorAll(`input[type='radio'][name='select_plan']`);
  const targetForm = document.querySelector('product-form form');
  const targetForm2 = document.querySelector('.product-form_fixed form');
  for (let target of selectPlan) {
    if (target.checked) {
      let list_element = document.querySelector(`input[name='selling_plan']`);
      var inputElem = document.createElement("input");
      inputElem.setAttribute("name", "selling_plan"),
      inputElem.setAttribute("type", "hidden"),
      inputElem.setAttribute("value", target.value),
      targetForm.appendChild(inputElem);
    }
    target.addEventListener(`change`, () => {
      let list_element = document.querySelector(`input[name='selling_plan']`);
      var inputElem = document.createElement("input");
      inputElem.setAttribute("name", "selling_plan"),
      inputElem.setAttribute("type", "hidden"),
      inputElem.setAttribute("value", target.value),
      setTimeout(() => {
        if (list_element != null) {
          list_element.remove();
        }
        targetForm.appendChild(inputElem);
      }, 200);
    });
  }

  for (let target of selectPlan) {
    if (target.checked) {
      let list_element = document.querySelector(`input[name='selling_plan']`);
      var inputElem = document.createElement("input");
      inputElem.setAttribute("name", "selling_plan"),
      inputElem.setAttribute("type", "hidden"),
      inputElem.setAttribute("value", target.value),
      targetForm2.appendChild(inputElem);
    }
    target.addEventListener(`change`, () => {
      let list_element = document.querySelector(`input[name='selling_plan']`);
      var inputElem = document.createElement("input");
      inputElem.setAttribute("name", "selling_plan"),
      inputElem.setAttribute("type", "hidden"),
      inputElem.setAttribute("value", target.value),
      setTimeout(() => {
        if (list_element != null) {
          list_element.remove();
        }
        targetForm2.appendChild(inputElem);
      }, 200);
    });
  }
});

/***20230720 add***/
document.addEventListener("DOMContentLoaded", () => {
  let targetForm = document.querySelector('product-form form');
  let input_sellings = targetForm.querySelector(`input[name='selling_plan']`);
  let cart_btn_box = targetForm.querySelector(`.product-form__buttons`);
  let cart_btn = cart_btn_box.querySelector(`.product-form__submit`);

  let doc_body = document.body;

  let input_selling_limit = 10000000000;
  let input_selling_timecnt = 0;
  let input_selling_interval = 100;

  const select_option_parent = document.querySelector('#subscription-select');
  const select_option = select_option_parent.querySelectorAll('[name=select_plan]');

  // console.log('result__');
  // console.log(select_option.length);

  if(select_option.length > 0) {
    setInterval(() => {

      targetForm = document.querySelector('product-form form');
      input_sellings = targetForm.querySelectorAll(`input[name='selling_plan']`);
      cart_btns_box = document.querySelectorAll(`.product-form__buttons`);
      cart_btn = cart_btn_box.querySelector(`.product-form__submit`);

      if(input_sellings.length <= 0) {
        if (doc_body.classList.contains('js-none-selling') == false) {
          doc_body.classList.add('js-none-selling');
        }
      }
      else {
        if (doc_body.classList.contains('js-none-selling') == true) {
          doc_body.classList.remove('js-none-selling');
        }
      }
    }, input_selling_interval);
  }
});
/***20230728 add***/
document.addEventListener('DOMContentLoaded', () => {

  function fixed_btn_adj() {

    let sel_footer_fixed = document.querySelector('.js-float_box_control'),
        sel_footer_getbound = sel_footer_fixed.getBoundingClientRect(); 

    let sel_fixed_area = document.querySelector('.product-form_fixed');
        sel_fixed_area.style.bottom = sel_footer_getbound.height + 'px';

        /*console.log(sel_fixed_area);*/
  }
  function fixed_cart_btn_dammy() {

    let sel_button_dammys = document.querySelectorAll('.js-fixed-purchase-dammy-btn'),
        sel_selector = document.getElementById('subscription-select');

    sel_button_dammys.forEach((sel_button_dammy,index) => {
      sel_button_dammy.addEventListener("click", () => {
        if(sel_selector !== null) {
          sel_selector.classList.add('js-select-btn-active');
        }

        //let current_scroll = window.e.preventDefault();
        const targetId = '#mobile-product__info-wrapper .product-allergy-list';
        //const targetId = link.hash;
        const targetElement = document.querySelector(targetId);
        const targetOffsetTop = window.scrollY + targetElement.getBoundingClientRect().top;
        const page_header = document.querySelector('.header-wrapper header.header');

        const header_height = page_header.getBoundingClientRect().height;

        window.scrollTo({
          top: targetOffsetTop - header_height,
          behavior: "smooth"
        });

        sel_button_dammys.forEach((sel_button_dammy,index) => {
          sel_button_dammy.remove();
        });
      });
    });
  }
  fixed_btn_adj();
  fixed_cart_btn_dammy();

  window.addEventListener('resize', () => {
    fixed_btn_adj();
  });
});

